module.exports = __webpack_public_path__ + "img/caselist20.62f6a6e8.jpg";